import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CallComponent} from './call.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzFormModule, NzButtonModule, NzIconModule, NzInputModule, NzSelectModule, NzGridModule} from 'ng-zorro-antd';

@NgModule({
  declarations: [CallComponent],
  exports: [
    CallComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    NzGridModule
  ]
})
export class CallModule {
}
